module.exports = {
  careerAndSchoolMatcherComponentEvents: {
    PickProfessions: {
      code: 'CareerAndSchoolMatcherCareerSearch',
      events: {
        CareerSearchPageView: {
          description: 'Triggered when user lands on the career search page',
          eventHub: {
            code: 'PageView',
            action: 'Career_Search_Page_View',
            dataKeys: ['pageNAme']
          },
          ga: {
            action: 'CSM - CareerSearch - Career_Search_Page_View'
          }
        }
      }
    },
    ProgramMatcherMap: {
      code: 'CareerAndSchoolMatcherMap',
      events: {
        MapPageView: {
          description: 'Triggered when user lands on the map page',
          eventHub: {
            code: 'PageView',
            action: 'Map_Page_View',
            dataKeys: ['pageNAme', 'searchTerm', 'userLocation']
          },
          ga: {
            action: 'CSM - MapPage - Map_Page_View'
          }
        },
        MapLoad: {
          description: 'Triggered when the map loads',
          eventHub: {
            code: 'MapLoad',
            action: 'Map_Load',
            dataKeys: ['addressType', 'locationPermission']
          },
          ga: {
            action: 'CSM - MapPage - Map_Load'
          }
        },
        MapZoom: {
          description: 'Triggered when the map zoom level changes',
          eventHub: {
            code: 'MapZoom',
            action: 'Map_Adjust_Zoom',
            dataKeys: ['zoomLevel']
          },
          ga: {
            action: 'CSM - MapPage - Map_Adjust_Zoom'
          }
        },
        MapRecenter: {
          description: 'Triggered when the map is recentered',
          eventHub: {
            code: 'MapRecenter',
            action: 'Map_Recenter',
            dataKeys: ['institutionName', 'institutionCoordinates']
          },
          ga: {
            action: 'CSM - MapPage - Map_Recenter'
          }
        },
        MapInstitutionPinClick: {
          description: 'Triggered when an institution pin is clicked on the map',
          eventHub: {
            code: 'MapInstitutionPinClick',
            action: 'Map_Institution_Pin_Click',
            dataKeys: ['institutionId', 'institutionName', 'institutionCoordinates']
          },
          ga: {
            action: 'CSM - MapPage - Map_Institution_Pin_Click'
          }
        },
        MapTransitFilterToggle: {
          description: 'Triggered when a user toggles the transit filter',
          eventHub: {
            code: 'FilterToggle',
            action: 'Map_Transit_Filter_Toggle',
            dataKeys: ['filterState']
          },
          ga: {
            action: 'CSM - MapPage - Map_Transit_Filter_Toggle'
          }
        },
        MapGroceryFilterToggle: {
          description: 'Triggered when a user toggles the grocery filter',
          eventHub: {
            code: 'FilterToggle',
            action: 'Map_Grocery_Filter_Toggle',
            dataKeys: ['filterState']
          },
          ga: {
            action: 'CSM - MapPage - Map_Grocery_Filter_Toggle'
          }
        },
        SelectSchoolFromList: {
          description: 'Triggered when a user clicks on an institution from the list view',
          eventHub: {
            code: 'SelectSchool',
            action: 'Map_Select_School_From_List',
            dataKeys: ['institutionId', 'institutionName']
          },
          ga: {
            action: 'CSM - MapPage - Select_School_From_List'
          }
        },
        ProgramPanelDisplay: {
          description: 'Triggered when programs list is displayed for a school',
          eventHub: {
            code: 'ProgramPanelDisplay',
            action: 'Map_Program_Panel_Display',
            dataKeys: ['institutionId', 'institutionName', 'programList']
          },
          ga: {
            action: 'CSM - MapPage - ProgramPanelDisplay'
          }
        },
        SelectProgram: {
          description: 'Triggered when a user selects a specific program from the panel.',
          eventHub: {
            code: 'SelectProgram',
            action: 'Select_Program',
            dataKeys: ['institutionId', 'programId', 'programName']
          },
          ga: {
            action: 'CSM - MapPage - Select_Program'
          }
        },
        SchoolListScroll: {
          description: 'Triggered when a user scrolls the school list.',
          eventHub: {
            code: 'Scroll',
            action: 'School_List_Scroll',
            dataKeys: ['scrollDepth']
          },
          ga: {
            action: 'CSM - MapPage - School_List_Scroll'
          }
        },
        ProgramListScroll: {
          description: 'Triggered when a user scrolls the program list.',
          eventHub: {
            code: 'Scroll',
            action: 'Program_List_Scroll',
            dataKeys: ['scrollDepth']
          },
          ga: {
            action: 'CSM - MapPage - Program_List_Scroll'
          }
        }
      }
    },
    ProgramMatcherResult: {
      code: 'CareerAndSchoolMatcherDetails',
      events: {
        DetailsPageView: {
          description: 'Triggered when user views the details page',
          eventHub: {
            code: 'PageView',
            action: 'Details_Page_View',
            dataKeys: ['institutionId, programId, comparisonInstitutions']
          },
          ga: {
            action: 'CSM - Results - Details_Page_View'
          }
        },
        PaywallPageView: {
          description: 'Triggered when user views the paywall page',
          eventHub: {
            code: 'PageView',
            action: 'Paywall_Page_View',
            dataKeys: ['pageName']
          },
          ga: {
            action: 'CSM - Results - Paywall_Page_View'
          }
        },
        DetailsTableFilter: {
          description: 'Triggered when user filters the comparison results',
          eventHub: {
            code: 'Filter',
            action: 'Comparison_Filter',
            dataKeys: ['comparisonInstitutions', 'filter']
          },
          ga: {
            action: 'CSM - Details - Comparison Table Filter'
          }
        },
        DetailsTableScroll: {
          description: 'Triggered when user scrolls the comparison results page',
          eventHub: {
            code: 'Scroll',
            action: 'Details_Page_scroll',
            dataKeys: ['scrollDepth']
          },
          ga: {
            action: 'CSM - Details - Details_Page_Scroll'
          }
        },
        SaveButtonClick: {
          description: 'Triggered when user clicks on Save button on CSM result screen',
          eventHub: {
            code: 'SaveButtonUnfilled',
            action: '[$.action]',
            dataKeys: ['userId', 'sessionId', 'program', 'school']
          },
          ga: {
            action: 'CSM - Details - saveButtonClick'
          }
        }
      }
    },
    CareerList: {
      code: 'CareerList',
      events: {
        CareerListPageDuration: {
          description:
            'Tracks the total time spent on the Career List page, Triggered when a user navigates away from the page',
          eventHub: {
            code: 'Duration',
            action: 'Career_List_duration',
            dataKeys: ['duration']
          },
          ga: {
            action: 'CSM - CareerList - Total time'
          }
        },
        IndustryClick: {
          description: 'Triggered when a user selects on an industry filter in the left pane.',
          eventHub: {
            code: 'IndustryClick',
            action: 'Industry_Filter_click',
            dataKeys: ['label', 'order']
          },
          ga: {
            action: 'CSM - Industry Click - [$.label], [$.order]'
          }
        },
        CareerClick: {
          description: 'Triggered when a user clicks on a career in the right pane.',
          eventHub: {
            code: 'CareerClick',
            action: 'Career_click',
            dataKeys: ['career', 'industry']
          },
          ga: {
            action: 'CSM - Career CLick - [$.career]'
          }
        },
        IndustryScrollDepth: {
          description: 'Triggered when the industries pane is vertically scrolled.',
          eventHub: {
            code: 'IndustryScrollDepth',
            action: 'Industry_Pane_scroll',
            dataKeys: ['scrollPercentage']
          },
          ga: {
            action: 'CSM - Career List - Industry pane scroll'
          }
        },
        IndustryScrollStart: {
          description: 'Triggered when the Industry pane beings scrolling.',
          eventHub: {
            code: 'IndustryScrollStart',
            action: 'Industry_scroll_start',
            dataKeys: ['scrollStartTime']
          },
          ga: {
            action: 'CSM - Career List - Industry pane scroll start'
          }
        },
        IndustryScrollEnd: {
          description: 'Triggered when srcollling stops of the Industry pane.',
          eventHub: {
            code: 'IndustryScrollEnd',
            action: 'Industry_scroll_end',
            dataKeys: ['scrollEndTime']
          },
          ga: {
            action: 'CSM - Career List - Industry pane scroll end'
          }
        },
        IndustryScrollIdleTime: {
          description: 'Triggered with the duration between scrolling events on the Industry pane.',
          eventHub: {
            code: 'IndustryScrollIdleTime',
            action: 'Industry_idle_scroll',
            dataKeys: ['timeSinceLastScroll']
          },
          ga: {
            action: 'CSM - Career List - Industry pane idle scroll time'
          }
        },
        CareerScrollDepth: {
          description: 'Triggered when the careers pane is vertically scrolled.',
          eventHub: {
            code: 'CareerScrollDepth',
            action: 'Careers_Pane_scroll',
            dataKeys: ['scrollPercentage']
          },
          ga: {
            action: 'CSM - Career List - Careers pane scroll'
          }
        },
        CareerScrollStart: {
          description: 'Triggered when the Career pane beings scrolling.',
          eventHub: {
            code: 'CareerScrollStart',
            action: 'Career_scroll_start',
            dataKeys: ['scrollStartTime']
          },
          ga: {
            action: 'CSM - Career List - Career pane scroll start'
          }
        },
        CareerScrollEnd: {
          description: 'Triggered when srcollling stops of the Career pane.',
          eventHub: {
            code: 'CareerScrollEnd',
            action: 'Career_scroll_end',
            dataKeys: ['scrollEndTime']
          },
          ga: {
            action: 'CSM - Career List - Career pane scroll end'
          }
        },
        CareerScrollIdleTime: {
          description: 'Triggered with the duration between scrolling events on the Career pane.',
          eventHub: {
            code: 'CareerScrollIdleTime',
            action: 'Career_idle_scroll',
            dataKeys: ['timeSinceLastScroll']
          },
          ga: {
            action: 'CSM - Career List - Career pane idle scroll time'
          }
        },
        SearchbarQuery: {
          description: 'Triggered when a user enters a query in the searchbar',
          eventHub: {
            code: 'SearchbarQuery',
            action: 'Career_List_Search_query',
            dataKeys: ['query', 'length']
          },
          ga: {
            action: 'CSM - Career List Search Query'
          }
        },
        ClearButtonClick: {
          description: 'Triggered when a user clicks the clear button in the searchbar',
          eventHub: {
            code: 'SearchbarClearButton',
            action: 'Clear_Button_click'
          },
          ga: {
            action: 'CSM - Career List - Clear Button Click'
          }
        },
        SearchbarClearInput: {
          description: 'Triggered when a user clicks on the "X" button in the searchbar',
          eventHub: {
            code: 'SearchbarClearInput',
            action: 'Search_clear_input'
          },
          ga: {
            action: 'CSM - Career List - Searchbar Clear Input'
          }
        }
      }
    }
  }
};
